import { Helmet } from "react-helmet-async";
import { SITE_DESCRIPTION, SITE_TITLE, SITE_URL } from "@/data/site";

export interface PageMetaProps {
  title?: string;
  description?: string;
  path?: string;
  dateModified?: string;
  ogType?: "website" | "article";
  ogImage?: string;
  noindex?: boolean;
  jsonLd?: object[];
}

export default function PageMeta({
  title = SITE_TITLE,
  description = SITE_DESCRIPTION,
  path = "/",
  dateModified,
  ogType = "website",
  ogImage = `${SITE_URL}/og-image.png`,
  noindex = false,
  jsonLd = [],
}: PageMetaProps) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {dateModified ? <meta property="article:modified_time" content={dateModified} /> : null}
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
      {jsonLd.map((entry, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
}
